import { render, staticRenderFns } from "./ReportGames.vue?vue&type=template&id=7215f356&scoped=true&"
import script from "./ReportGames.vue?vue&type=script&lang=js&"
export * from "./ReportGames.vue?vue&type=script&lang=js&"
import style0 from "./ReportGames.vue?vue&type=style&index=0&id=7215f356&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215f356",
  null
  
)

export default component.exports